import H4 from './H4';

function UpcomingDates() {
  return (
    <div className=" mx-auto w-full rounded-xl bg-tertiary-extraLight">
      <div className="flex flex-col p-6">
        <H4 className="text-dark-900" text="New upcoming dates will be scheduled soon" />
        <p className="text-base text-dark-900">Join our newsletter to be the first to know.</p>
        <div className="flex flex-col pt-6">
          <a
            href={process.env.NEXT_PUBLIC_MAILCHIMP_WAITINGLIST_FORM_URL}
            target="_blank"
            rel="noreferrer"
          >
            <button
              type="button"
              className="mt-2 w-full rounded-full bg-dark-900 py-3 font-poppins text-base font-medium text-white"
            >
              Join waiting list
            </button>
          </a>
        </div>
      </div>
    </div>
  );
}

export default UpcomingDates;
